import React from 'react';
import { Skeleton } from '@mui/material';

const SkeletonLoader = ({ variant = 'rectangular', width, height, sx = {} }) => {
  return (
    <Skeleton
      variant={variant}
      width={width}
      height={height}
      animation="wave"
      sx={{
        backgroundColor: '#f0f0f0',
        '&::after': {
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
          animation: 'wave 1.5s ease-in-out infinite',
        },
        '@keyframes wave': {
          '0%': {
            transform: 'translateX(-100%)',
          },
          '100%': {
            transform: 'translateX(100%)',
          },
        },
        ...sx
      }}
    />
  );
};

export { default as FacturaSkeleton } from './FacturaSkeleton';
export { default as HonorariosSkeleton } from './HonorariosSkeleton';
export { default as PerfilSkeleton } from './PerfilSkeleton';
export { default as ConsultasSkeleton } from './ConsultasSkeleton';
export default SkeletonLoader;
